// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes slideInUpText {
  0% {
    -webkit-transform: translateY(5px);
    transform: translateY(5px);
    visibility: visible;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
.dis-none {
  display: none;
}

.widget-footer-wrapper {
  display: inline-block;
  width: 100%;
  position: relative;
}
.widget-footer-wrapper .logo-left-menu {
  display: none;
}
.widget-footer-wrapper .line-divider {
  background: var(--AA-gloabl-bg-secondary);
  width: 10px;
  height: 2px;
  display: none;
  border-radius: 4px;
  margin: 0 auto;
  flex-shrink: 0;
}
.widget-footer-wrapper .footer-links-data {
  display: flex;
  padding: 8px 16px;
  width: 100%;
  gap: 32px;
  min-height: 50px;
}
@media screen and (max-width: 500px) {
  .widget-footer-wrapper .footer-links-data {
    gap: initial;
  }
}
.widget-footer-wrapper .footer-links-data .logo-sec {
  display: none;
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons {
  width: 100%;
  display: flex;
  align-items: center;
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer {
  border: 0;
  padding: 0;
  background: transparent;
  min-width: 62px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1;
  transition: 0.2s all ease;
  color: var(--AA-gloabl-text-color);
  border-radius: 45px;
}
@media screen and (max-width: 600px) {
  .widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer {
    flex-direction: column;
  }
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.selected-tab {
  color: var(--AA-global-theme-text-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.selected-tab p {
  display: block;
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.selected-tab svg path {
  stroke: var(--AA-global-white-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.selected-tab.aa-footer-btn-srch svg path {
  fill: var(--AA-global-white-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.sel-bg.selected-tab {
  background: var(--AA-global-theme-bg);
  color: var(--AA-global-white-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.sel-bg.selected-tab svg path {
  stroke: var(--AA-global-white-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.sel-bg.selected-tab.aa-footer-btn-srch svg path {
  fill: var(--AA-global-white-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.sel-bg:hover {
  background: var(--AA-global-theme-bg);
  color: var(--AA-global-white-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.aa-footer-btn-srch svg path {
  fill: var(--AA-gloabl-text-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.aa-footer-btn-mB svg path {
  stroke: var(--AA-gloabl-text-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.aa-footer-btn-ast svg path {
  stroke: var(--AA-gloabl-text-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.aa-footer-btn-cst svg path {
  stroke: var(--AA-gloabl-text-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.aa-footer-btn-cl svg path {
  stroke: var(--AA-gloabl-text-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.aa-footer-btn-mR svg path {
  stroke: var(--AA-gloabl-text-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.aa-footer-btn-trnspt svg path {
  stroke: var(--AA-gloabl-text-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer:hover {
  color: var(--AA-global-theme-text-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer:hover p {
  display: block;
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer:hover svg path {
  stroke: var(--AA-global-theme-text-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer:hover.aa-footer-btn-srch svg path {
  fill: var(--AA-global-theme-text-color);
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer .svg_icon {
  line-height: 0;
  font-size: 16px;
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer .svg_icon.custom-tab-icon svg {
  width: 14px;
  height: 14px;
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer .svg_icon svg {
  width: 18px;
  height: 18px;
}
.widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer p {
  margin: 0;
  font-size: 10px;
  font-weight: 600;
  line-height: normal;
  -webkit-animation-name: slideInUpText;
  animation-name: slideInUpText;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.widget-footer-wrapper .settings-dark-theme {
  display: none;
}
.widget-footer-wrapper .footer-action-items {
  padding: 10px 0;
  display: none;
}

nav {
  display: block;
  height: 100%;
  width: 100%;
  border-radius: 4px 0px 0px 4px;
  background: var(--AA-global-theme-bg);
}
nav .widget-footer-wrapper {
  height: 100%;
  border-radius: 4px 0px 0px 4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
}
nav .widget-footer-wrapper .logo-left-menu {
  display: flex;
  align-items: center;
  height: 48px;
  justify-content: center;
  border-radius: 4px;
  width: 100%;
  background: var(--AA-gloabl-bg-secondary);
}
nav .widget-footer-wrapper .logo-left-menu svg {
  stroke: var(--AA-gloabl-text-color);
}
nav .widget-footer-wrapper .line-divider {
  display: block;
}
nav .widget-footer-wrapper .footer-links-data {
  flex-direction: column;
  padding: 0px;
  gap: 12px;
  flex: 1 1 auto;
  overflow: auto;
}
nav .widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer {
  flex-direction: column;
  padding: 8px 0;
  border-radius: 4px;
  gap: 8px;
  min-width: auto;
  height: auto;
  overflow: hidden;
}
nav .widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer p {
  font-weight: 500;
  width: 100%;
}
nav .widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer svg path {
  stroke: var(--AA-gloabl-text-color);
}
nav .widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.aa-footer-btn-srch svg path {
  fill: var(--AA-gloabl-text-color);
}
nav .widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.selected-tab {
  color: var(--AA-global-theme-text-color) !important;
  background: var(--AA-gloabl-bg-secondary) !important;
}
nav .widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.selected-tab svg path {
  stroke: var(--AA-global-theme-text-color) !important;
}
nav .widget-footer-wrapper .footer-links-data .footer-list-buttons .btn_footer.selected-tab.aa-footer-btn-srch svg path {
  fill: var(--AA-global-theme-text-color) !important;
}
nav .widget-footer-wrapper .settings-dark-theme {
  flex-shrink: 0;
  display: flex !important;
  flex-direction: column;
  gap: 8px;
}
nav .widget-footer-wrapper .settings-dark-theme button {
  display: flex;
  padding: 0px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border: 0;
  background: transparent;
  height: 32px;
  justify-content: center;
  font-size: 16px;
  color: var(--AA-gloabl-text-color);
  transition: 0.2s all ease;
}
nav .widget-footer-wrapper .settings-dark-theme button:hover, nav .widget-footer-wrapper .settings-dark-theme button.selected-tab-action {
  color: var(--AA-global-theme-text-color);
}
nav .widget-footer-wrapper .footer-action-items {
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/common/templatemanager/tabs/all-tabs.scss"],"names":[],"mappings":"AACA;EACI;IACI,kCAAA;IACA,0BAAA;IACA,mBAAA;EAAN;EAGE;IACI,gCAAA;IACA,wBAAA;EADN;AACF;AAIA;EACI,aAAA;AAFJ;;AAQA;EACI,qBAAA;EACA,WAAA;EACA,kBAAA;AALJ;AAMI;EACI,aAAA;AAJR;AAMI;EACI,yCAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;AAJR;AAQI;EACI,aAAA;EACA,iBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;AANR;AAOQ;EANJ;IAOQ,YAAA;EAJV;AACF;AAKQ;EACI,aAAA;AAHZ;AAKQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;AAHZ;AAIY;EACI,SAAA;EACA,UAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;EACA,yBAAA;EACA,kCAAA;EACA,mBAAA;AAFhB;AAGgB;EAdJ;IAeQ,sBAAA;EAAlB;AACF;AACgB;EACI,wCAAA;AACpB;AAAoB;EACI,cAAA;AAExB;AACwB;EACI,oCAAA;AAC5B;AAI4B;EACI,kCAAA;AAFhC;AAQoB;EACI,qCAAA;EACA,mCAAA;AANxB;AAS4B;EACI,oCAAA;AAPhC;AAYgC;EACI,kCAAA;AAVpC;AAeoB;EACI,qCAAA;EACA,mCAAA;AAbxB;AAmBwB;EACI,iCAAA;AAjB5B;AAuBwB;EACI,mCAAA;AArB5B;AA2BwB;EACI,mCAAA;AAzB5B;AA+BwB;EACI,mCAAA;AA7B5B;AAmCwB;EACI,mCAAA;AAjC5B;AAuCwB;EACI,mCAAA;AArC5B;AA2CwB;EACI,mCAAA;AAzC5B;AA6CgB;EACI,wCAAA;AA3CpB;AA4CoB;EACI,cAAA;AA1CxB;AA6CwB;EACI,yCAAA;AA3C5B;AAgD4B;EACI,uCAAA;AA9ChC;AAmDgB;EACI,cAAA;EACA,eAAA;AAjDpB;AAmDwB;EACI,WAAA;EACA,YAAA;AAjD5B;AAoDoB;EACI,WAAA;EACA,YAAA;AAlDxB;AAqDgB;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qCAAA;EACA,6BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AAnDpB;AAyDI;EACI,aAAA;AAvDR;AAyDI;EACI,eAAA;EACA,aAAA;AAvDR;;AA2DA;EACI,cAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;EACA,qCAAA;AAxDJ;AAyDI;EACI,YAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;AAvDR;AAwDQ;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,yCAAA;AAtDZ;AAuDY;EACI,mCAAA;AArDhB;AAwDQ;EACI,cAAA;AAtDZ;AAyDQ;EACI,sBAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,cAAA;AAvDZ;AAyDgB;EACI,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AAvDpB;AAwDoB;EACI,gBAAA;EACA,WAAA;AAtDxB;AAyDwB;EACI,mCAAA;AAvD5B;AA4D4B;EACI,iCAAA;AA1DhC;AA8DoB;EACI,mDAAA;EACA,oDAAA;AA5DxB;AA8D4B;EACI,oDAAA;AA5DhC;AAiEgC;EACI,kDAAA;AA/DpC;AAuEQ;EACI,cAAA;EACA,wBAAA;EACA,sBAAA;EACA,QAAA;AArEZ;AAuEY;EACI,aAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,kCAAA;EACA,yBAAA;AArEhB;AAuEgB;EAEI,wCAAA;AAtEpB;AA0EQ;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxEZ","sourcesContent":["\n@keyframes slideInUpText {\n    0% {\n        -webkit-transform: translateY(5px);\n        transform: translateY(5px);\n        visibility: visible;\n    }\n\n    100% {\n        -webkit-transform: translateY(0);\n        transform: translateY(0);\n    }\n}\n\n.dis-none {\n    display: none;\n}\n@function color-with-opacity($color, $opacity) {\n    @return rgba($color, $opacity);\n}\n\n.widget-footer-wrapper {\n    display: inline-block;\n    width: 100%;\n    position: relative;\n    .logo-left-menu{\n        display: none;\n    }\n    .line-divider {\n        background: var(--AA-gloabl-bg-secondary);\n        width: 10px;\n        height: 2px;\n        display: none;\n        border-radius: 4px;\n        margin: 0 auto;\n        flex-shrink: 0;\n    }\n\n\n    .footer-links-data {\n        display: flex;\n        padding: 8px 16px;\n        width: 100%;\n        gap: 32px;\n        min-height: 50px;\n        @media screen and (max-width: 500px) {\n            gap: initial;\n        }\n        .logo-sec {\n            display: none;\n        }\n        .footer-list-buttons{\n            width: 100%;\n            display: flex;\n            align-items: center;\n            .btn_footer {\n                border: 0;\n                padding: 0;\n                background: transparent;\n                min-width: 62px;\n                height: 40px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                gap: 4px;\n                flex: 1;\n                transition: 0.2s all ease;\n                color: var(--AA-gloabl-text-color);\n                border-radius: 45px;\n                @media screen and (max-width: 600px) {\n                    flex-direction: column;\n                }\n                &.selected-tab {\n                    color: var(--AA-global-theme-text-color);\n                    p {\n                        display: block;\n                    }\n                    svg{\n                        path{\n                            stroke: var(--AA-global-white-color);\n                        }\n                    }\n                    &.aa-footer-btn-srch{\n                        svg{\n                            path{\n                                fill: var(--AA-global-white-color);\n                            }\n                        }\n                    }\n                }\n                &.sel-bg {\n                    &.selected-tab {\n                        background: var(--AA-global-theme-bg);\n                        color: var(--AA-global-white-color);\n                        // background: color-with-opacity($a, 0.14);\n                        svg{\n                            path{\n                                stroke: var(--AA-global-white-color);\n                            }\n                        }\n                        &.aa-footer-btn-srch{\n                            svg{\n                                path{\n                                    fill: var(--AA-global-white-color);\n                                }\n                            }\n                        }\n                    }\n                    &:hover {\n                        background: var(--AA-global-theme-bg);\n                        color: var(--AA-global-white-color);\n                        // background: color-with-opacity($a, 0.14);\n                    }\n                }\n                &.aa-footer-btn-srch{\n                    svg{\n                        path{\n                            fill: var(--AA-gloabl-text-color);\n                        }\n                    }\n                }\n                &.aa-footer-btn-mB{\n                    svg{\n                        path{\n                            stroke: var(--AA-gloabl-text-color);\n                        }\n                    }\n                }\n                &.aa-footer-btn-ast{\n                    svg{\n                        path{\n                            stroke: var(--AA-gloabl-text-color);\n                        }\n                    }\n                }\n                &.aa-footer-btn-cst{\n                    svg{\n                        path{\n                            stroke: var(--AA-gloabl-text-color);\n                        }\n                    }\n                }\n                &.aa-footer-btn-cl{\n                    svg{\n                        path{\n                            stroke: var(--AA-gloabl-text-color);\n                        }\n                    }\n                }\n                &.aa-footer-btn-mR{\n                    svg{\n                        path{\n                            stroke: var(--AA-gloabl-text-color);\n                        }\n                    }\n                }\n                &.aa-footer-btn-trnspt{\n                    svg{\n                        path{\n                            stroke: var(--AA-gloabl-text-color);\n                        }\n                    }\n                }\n                &:hover {\n                    color: var(--AA-global-theme-text-color);\n                    p {\n                        display: block;\n                    }\n                    svg{\n                        path{\n                            stroke: var(--AA-global-theme-text-color);\n                        }\n                    }\n                    &.aa-footer-btn-srch{\n                        svg{\n                            path{\n                                fill: var(--AA-global-theme-text-color);\n                            }\n                        }\n                    }\n                }\n                .svg_icon {\n                    line-height: 0;\n                    font-size: 16px;\n                    &.custom-tab-icon{\n                        svg{\n                            width: 14px;\n                            height: 14px;\n                        }\n                    }\n                    svg{\n                        width: 18px;\n                        height: 18px;\n                    }\n                }\n                p {\n                    margin: 0;\n                    font-size: 10px;\n                    font-weight: 600;\n                    line-height: normal;\n                    -webkit-animation-name: slideInUpText;\n                    animation-name: slideInUpText;\n                    -webkit-animation-duration: 1s;\n                    animation-duration: 1s;\n                    -webkit-animation-fill-mode: both;\n                    animation-fill-mode: both;\n                }\n            }\n        }\n    }\n\n    .settings-dark-theme {\n        display: none;\n    }\n    .footer-action-items{\n        padding: 10px 0;\n        display: none;\n    }\n}\n\nnav {\n    display: block;\n    height: 100%;\n    width: 100%;\n    border-radius: 4px 0px 0px 4px;\n    background: var(--AA-global-theme-bg);\n    .widget-footer-wrapper {\n        height: 100%;\n        border-radius: 4px 0px 0px 4px;\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n        justify-content:center;\n        .logo-left-menu{\n            display: flex;\n            align-items: center;\n            height: 48px;\n            justify-content: center;\n            border-radius: 4px;\n            width: 100%;\n            background: var(--AA-gloabl-bg-secondary);\n            svg {\n                stroke: var(--AA-gloabl-text-color);\n            }\n        }\n        .line-divider {\n            display: block;\n        }\n\n        .footer-links-data {\n            flex-direction: column;\n            padding: 0px;\n            gap: 12px;\n            flex: 1 1 auto;\n            overflow: auto;\n            .footer-list-buttons{\n                .btn_footer {\n                    flex-direction: column;\n                    padding: 8px 0;\n                    border-radius: 4px;\n                    gap: 8px;\n                    min-width: auto;\n                    height: auto;\n                    overflow: hidden;\n                    p {\n                        font-weight: 500;\n                        width: 100%;\n                    }\n                    svg{\n                        path{\n                            stroke: var(--AA-gloabl-text-color);\n                        }\n                    }\n                    &.aa-footer-btn-srch{\n                        svg{\n                            path{\n                                fill: var(--AA-gloabl-text-color);\n                            }\n                        }\n                    }\n                    &.selected-tab {\n                        color: var(--AA-global-theme-text-color) !important;\n                        background: var(--AA-gloabl-bg-secondary) !important;\n                        svg{\n                            path{\n                                stroke: var(--AA-global-theme-text-color) !important;\n                            }\n                        }\n                        &.aa-footer-btn-srch{\n                            svg{\n                                path{\n                                    fill: var(--AA-global-theme-text-color) !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .settings-dark-theme {\n            flex-shrink: 0;\n            display: flex !important;\n            flex-direction: column;\n            gap: 8px;\n\n            button {\n                display: flex;\n                padding: 0px;\n                flex-direction: column;\n                align-items: center;\n                gap: 8px;\n                align-self: stretch;\n                border: 0;\n                background: transparent;\n                height: 32px;\n                justify-content: center;\n                font-size: 16px;\n                color: var(--AA-gloabl-text-color);\n                transition: 0.2s all ease;\n\n                &:hover,\n                &.selected-tab-action {\n                    color: var(--AA-global-theme-text-color);\n                }\n            }\n        }\n        .footer-action-items{\n            padding: 10px 0;\n            display: flex;\n            align-items: center;\n            justify-content:center;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
